import { USER_INPUT_EVENTS } from "core/utils/constants";

export const addListeners = (listener: () => void) => {
  USER_INPUT_EVENTS.forEach((event: string) =>
    document.addEventListener(event, listener)
  );
};

export const removeListeners = (listener: () => void) => {
  USER_INPUT_EVENTS.forEach((event: string) =>
    document.removeEventListener(event, listener)
  );
};
